import { render, staticRenderFns } from "./ListingHeader.vue?vue&type=template&id=61895f4a"
import script from "./ListingHeader.vue?vue&type=script&lang=js"
export * from "./ListingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports